import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Case } from '../models/case';
import { ApiService } from './api.service';
import { start } from 'repl';

@Injectable()
export class CaseService {

  apiService: ApiService = new ApiService(this.http);

  caseDetails: {};

  static baseURL = environment.casesLink;
  static formURL = environment.formsLink;

  constructor(
    private http: Http
  ) { }

  // GET

  getAllCases(orgId: string) {
    return this.apiService.getCall('casesLink', `organizations/${orgId}/cases/`);
  }

  getCasesByStatus(orgId: string, status: any) {
    return this.apiService.getCall('casesLink', `organizations/${orgId}/cases?status=${status}`);
  }

  getCaseById(orgId: string, caseId: string) {
    // return this.apiService.getCall('casesLink', `organizations/${orgId}/cases/${caseId}`);
    return this.apiService.getCall('casesLink', `cases/${caseId}`);
  }

  getCasesByUserId(org: string, userId: string) {
    // return this.apiService.getCall('casesLink', `organization/${org}/users/${userId}/cases`);
    return this.apiService.getCall('casesLink', `users/${userId}/cases`);
  }

  getCaseScehma(form: string) {
    return this.apiService.getLocalCall(`${form}.json`);
  }

  getCaseAccountTrasactions(day, caseId, accountId) {
    return this.apiService.getCall('TRANSACTIONS_BY_DAY', `/transactions/day/${day}/case/${caseId}/${accountId}`)
  }

  getCaseTransaction(orgId, caseId, start_date, end_date) {
    // return this.apiService.getCall('casesLink', `organizations/${orgId}/cases/${caseId}/transactions/start/${start_date}/end/${end_date}`)
    return this.apiService.getCall('casesLink', `cases/${caseId}/transactions/start/${start_date}/end/${end_date}`)
  }

  // POST

  postCase(orgId: string, userId: string, formId, caseData) {
    return this.apiService.postCall('casesLink', `organizations/${orgId}/cases`, caseData);
  }

  postNewCase(orgId: string, userId: string, formId, caseData) {
    // return this.apiService.postCall('casesNewLink', `organizations/${orgId}/cases_new`, caseData);
    return this.apiService.postCall('casesNewLink', `cases_new`, caseData);
  }

  generatePDF(orgId: string, caseId: string, formId: string, data: any) {
    // return this.apiService.postCall('casesLink', `organizations/${orgId}/cases/${caseId}/fill/${formId}`, data);
    return this.apiService.postCall('casesLink', `cases/${caseId}/fill/${formId}`, data);
  }

  postTwoEight(caseId: string, tempId: string, data: any) {
    return this.apiService.postCall('casesLink', `cases/${caseId}/dueform/${tempId}/twoeight`, data);
  }

  postDueForm(caseId: string, tempId: string, data: any) {
    return this.apiService.postCall('casesNewLink', `cases/${caseId}/form/${tempId}`, data);
  }

  postHearingDate(orgId: string, caseId: string, formId: string, data: any) {
    // return this.apiService.postCall('casesLink', `organizations/${orgId}/cases/${caseId}/hearing`, data);
    return this.apiService.postCall('casesLink', `cases/${caseId}/hearing`, data);
  }

  postGuardians(caseId: string, data: any) {
    return this.apiService.postCall('casesLink', `cases/${caseId}/acceptance`, data);
  }

  patchGuardians(caseId: string, data: any) {
    return this.apiService.patchCall(`${CaseService.baseURL}cases/${caseId}/acceptance`, data);
  }

  postAcceptance(orgId: string, caseId: string, data: any) {
    return this.apiService.postCall('casesLink', `organizations/${orgId}/cases/'${caseId}/approvedecline`, data);
  }

  postSevenOne(organizationId: string, caseId: string, data: any) {
    // return this.apiService.postCall('casesLink', `organizations/${organizationId}/cases/${caseId}/sevenone`, data);
    return this.apiService.postCall('casesLink', `cases/${caseId}/sevenone`, data);
  }

  // PUT
  putCaseNew(orgId: string, caseId: string, caseData) {
    return this.apiService.putCall('casesNewLink', `organizations/${orgId}/cases_new/${caseId}`, caseData);
  }

  putTwoEight(caseId: string, formId: string, status: string, data: any) {
    return this.apiService.putCall('casesLink', `cases/${caseId}/forms/${formId}/status/${status}`, data);
  }

  putDueForm(caseId, formId, status: string, data) {
    return this.apiService.putCall('casesLink', `cases/${caseId}/forms/${formId}/status/${status}`, data);
  }

  putCaseWard(orgId: string, caseId: string, caseWard) {
    return this.apiService.putCall('casesLink', `organizations/${orgId}/cases/${caseId}/updatewarddetails`, caseWard);
  }

  putCaseGuardian(orgId: string, caseId: string, caseGuardian) {
    return this.apiService.putCall('casesLink', `organizations/${orgId}/cases/${caseId}/updateguardiandetails`, caseGuardian);
  }

  getSystemGeneratedAndUserUploadedCasePdfDifferences(orgId: string, caseId: string, formId: string) {
    return this.apiService.getCall('PDF_DIFFERENCES_API', `organizations/${orgId}/cases/${caseId}/file/${formId}`)
  }

  getCaseRecentActivity(orgId: string, caseId: string) {
    return this.apiService.getCall('activitiesLink', `organizations/${orgId}/cases/${caseId}/activities`);
  }
  getGuardianItem(orgId: string, caseId: string,caseNumber :string) {
    return this.apiService.getCall('casesLink', `organizations/${orgId}/cases/${caseId}/guardian_adlitem/${caseNumber}`);
  }
  postActivity(organizationId: string, caseId: string, data: any) {
    return this.apiService.postCall('casesNewLink', `cases/${caseId}/activities`, data);
  }
  postGuardianAdlitem(organizationId: string, caseId: string, data: any) {
    return this.apiService.postCall('casesLink', `organizations/${organizationId}/cases/${caseId}/guardian_adlitem_decision`, data);
  }

  getCaseHearingDates(organizationId: string) {
    return this.apiService.getCall('casesNewLink', `organizations/${organizationId}/hearingdate`);
  }

  putStatusUpdate(caseId: string, form_id: string, status: string) {
    return this.apiService.putCall('casesNewLink', `cases/${caseId}/form/${form_id}/${status}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/case.service.ts